export const FULL_ELECTRIC_FUEL_TYPE = "Elektra";
const WINTER_MONTHS = [11, 12, 1, 2, 3];

export function isFullElectricVehicle(
  fuelType?: string | null
): boolean {
  return fuelType === FULL_ELECTRIC_FUEL_TYPE;
}

export function getMonthMileage(
  startOfMonthKm?: number | string | null,
  endOfMonthKm?: number | string | null
): number {
  const start = Number(startOfMonthKm || 0);
  const end = Number(endOfMonthKm || 0);
  if (Number.isNaN(start) || Number.isNaN(end)) {
    return 0;
  }
  return Math.round(end - start);
}

export function getSeasonalConsumptionRate(
  winterRate?: number | string | null,
  summerRate?: number | string | null,
  period?: string
): number {
  const month = parseInt(String(period || "").split("-")[1], 10);
  const isWinter = WINTER_MONTHS.includes(month);
  return Number(isWinter ? winterRate : summerRate) || 0;
}

export function calculateWorkPurposeKmFromRate(
  quantity?: number | string | null,
  ratePer100Km?: number | string | null
): number {
  const qty = Number(quantity || 0);
  const rate = Number(ratePer100Km || 0);
  if (rate > 0 && qty > 0) {
    return Math.round((qty / rate) * 100);
  }
  return 0;
}

export function getNonWorkPurposeKm(
  monthMileage: number,
  workPurposeKm?: number | string | null
): number {
  const workKm = Number(workPurposeKm || 0);
  if (Number.isNaN(workKm)) {
    return monthMileage;
  }
  return Math.max(0, Math.round(monthMileage - workKm));
}

export function getFuelReportTotalAmount(report?: {
  totalPrice?: number | string | null;
  fuelExpenses?: number | string | null;
  additionalExpenses?: number | string | null;
  evChargeAmount?: number | string | null;
} | null): number {
  const electricity = Number(report?.evChargeAmount || 0);
  const evTotal = Number.isNaN(electricity) ? 0 : electricity;

  const hasExpenseParts =
    report?.fuelExpenses != null || report?.additionalExpenses != null;
  if (hasExpenseParts) {
    const fuel = Number(report?.fuelExpenses || 0);
    const extra = Number(report?.additionalExpenses || 0);
    return (
      (Number.isNaN(fuel) ? 0 : fuel) +
      (Number.isNaN(extra) ? 0 : extra) +
      evTotal
    );
  }

  const stored = Number(report?.totalPrice || 0);
  return (Number.isNaN(stored) ? 0 : stored) + evTotal;
}
